<template>
      <el-pagination
        v-if="pageState"
        :disabled="total === 0"
        background
        class="table-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size=pageData.pageSize
        :pager-count="5"
        :page-sizes="pageData.pageSizes || []"
        :layout=pageData.layout
        :total=total>
      </el-pagination>
</template>
<script>
export default {
    name: 'mPage',
    props: {
        total: {
            type: Number,
            default: 0
        },
        pageData: {
            type: Object
        },
        pageSize: {
            type: Number,
            default: 10
        },
        pageSizeOpts: {
            type: Array
        },
        currentPage: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            pageState: true
        };
    },
    methods: {
        handleSizeChange(page) {
            this.$emit('on-size-change', page);
        },
        handleCurrentChange(pageSize) {
            this.$emit('on-page-change', pageSize);
        }
    },
    created () {
        this.pageData.pageSize = this.pageData.pageSize || 10;
    }
};
</script>
<style lang="less">
.table-pagination{
    float: right;
    padding: 0;
    .el-pager li.active + li {
        border-left: 1px solid #cccccc;
    }
    .el-pager li:not(.disabled).active{
        border: 1px solid #00BCBF;
    }
}
.el-pagination.is-background{
    .btn-prev, .btn-next, .el-pager li{
        background-color: #ffffff;
        border: 1px solid #cccccc;
        border-radius: 4px;
    }
}
</style>
